import { apiFetch } from './apiClient';



/* Todos os menus do sistema (mesma lista do backend) */
export const MENUS_SISTEMA = [
  { key: 'dashboard',                        label: 'Dashboard',       grupo: null },
  { key: 'clientes/leads',                   label: 'Leads',           grupo: 'Clientes' },
  { key: 'clientes/onboard',                 label: 'Onboard',         grupo: 'Clientes' },
  { key: 'clientes/clientes',                label: 'Clientes',        grupo: 'Clientes', hint: 'cards visíveis' },
  /* cards visíveis na página Clientes — filhos de clientes/clientes */
  { key: 'clientes/clientes/acessos',        label: 'Acessos',         grupo: 'Clientes', parent: 'clientes/clientes' },
  { key: 'clientes/clientes/dados',          label: 'Dados Cadastrais',grupo: 'Clientes', parent: 'clientes/clientes' },
  { key: 'clientes/clientes/contratos',      label: 'Contratos',       grupo: 'Clientes', parent: 'clientes/clientes' },
  { key: 'clientes/clientes/nibo',           label: 'Vincular Nibo',   grupo: 'Clientes', parent: 'clientes/clientes' },
  { key: 'clientes/clientes/nf',             label: 'Parâmetros de NF', grupo: 'Clientes', parent: 'clientes/clientes' },
  { key: 'clientes/clientes/fornecedores',   label: 'Fornecedores',    grupo: 'Clientes', parent: 'clientes/clientes' },
  { key: 'clientes/procuracoes',             label: 'Procurações',     grupo: 'Clientes' },
  { key: 'clientes/certificados',            label: 'Certificados',    grupo: 'Clientes' },
  { key: 'clientes/licenciamento',           label: 'Licenciamento',   grupo: 'Clientes' },
  { key: 'financeiro',                       label: 'Financeiro',      grupo: null },
  { key: 'rotinas',                          label: 'Painel',          grupo: 'Obrigações' },
  { key: 'rotinas/tarefas',                  label: 'Tarefas',         grupo: 'Obrigações' },
  { key: 'rotinas/cadastro',                 label: 'Rotinas',         grupo: 'Obrigações' },
  { key: 'rotinas/processos',                label: 'Processos',       grupo: 'Obrigações' },
  /* NF virou menu com duas telas -- a chave 'nf' continua sendo a de
     NF-Essensials (mesma de antes), pra quem já tinha permissão não
     perder o acesso quando o menu foi dividido */
  { key: 'nf',                               label: 'NF-Essensials',   grupo: 'NF' },
  { key: 'nf/clientes',                      label: 'NF-Clientes',     grupo: 'NF' },
  { key: 'nf/consulta',                      label: 'Consulta NFS',    grupo: 'NF' },
  { key: 'nf/produtos',                      label: 'Consulta NF Produtos', grupo: 'NF' },
  { key: 'nf/cte',                           label: 'Consulta CT-e', grupo: 'NF' },
  { key: 'nf/nfce',                          label: 'Consulta NFC-e (SP)', grupo: 'NF' },
  { key: 'pdf',                              label: 'PDF',             grupo: null },
  { key: 'arquivos',                         label: 'Docs',            grupo: null },
  { key: 'relatorios',                       label: 'Relatórios',      grupo: null },
  { key: 'atendimento',                      label: 'Atendimento',     grupo: null },
  { key: 'email',                            label: 'E-mail',          grupo: null },
  { key: 'configuracoes',                    label: 'Configurações',   grupo: null },
  { key: 'auditoria',                        label: 'Auditoria',       grupo: null },
];

export async function buscarMinhasPermissoes() {
  return apiFetch('/permissoes/me');
}

export async function buscarPermissoesUsuario(authUserId) {
  return apiFetch(`/permissoes/usuario/${authUserId}`);
}

export async function salvarPermissoesUsuario(authUserId, menus) {
  return apiFetch(`/permissoes/usuario/${authUserId}`, {
    method: 'PUT',
    body: JSON.stringify({ menus }),
  });
}
